import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';

export const extractPlaceNameByType = (value, type) => {
  const placeType = value.mbId.split('.')[0];

  if (placeType === type) {
    return value;
  }

  if (!value.placeContext) {
    return null;
  }

  return _find(value.placeContext, item => item.id.split('.')[0] === type);
};

export const extractPlaceDestination = destinationInfo => {
  if (typeof destinationInfo === 'string') {
    return destinationInfo;
  }

  return destinationInfo.placeName;
};

export const extractPlaceParams = destinationInfo => {
  // Guard: an unresolved lookup (searchPlaces returned no results) must not
  // produce params — encodeURI(undefined) becomes the literal string
  // "undefined" in the URL and breaks the /destination/:country?/:place? route.
  if (destinationInfo === null || destinationInfo === undefined) {
    return null;
  }

  if (destinationInfo && destinationInfo.mbId) {
    const country = extractPlaceNameByType(destinationInfo, 'country');

    const place = extractPlaceNameByType(
      destinationInfo,
      destinationInfo.mbId.split('.')[0]
    );

    return country
      ? {
          country: encodeURI(country.text),
          place: encodeURI(place.text)
        }
      : {
          country: encodeURI(place.text),
          place: undefined
        };
  }

  return {
    place: encodeURI(destinationInfo)
  };
};

export const getNavigateToDestinationParams = (
  route,
  destinationInfo,
  query
) => {
  if (query) {
    delete query.mlt;
  }

  const params = extractPlaceParams(destinationInfo);

  if (!params) {
    return false;
  }

  if (query) {
    if (_isEqual(route.params, params) && _isEqual(route.query, query)) {
      return false;
    }

    return {
      name: 'destination',
      params: params,
      query: query
    };
  } else {
    if (_isEqual(route.params, params)) {
      return false;
    }

    return {
      name: 'destination',
      params: params
    };
  }
};
